import React, { useState } from "react";
import "./styles.css";

export default function HelpSupportUI() {
  const [active, setActive] = useState(2);

  const faqs = [
    { id: 1, q: "What is an impression?", a: "An impression is counted each time your property listing is shown to a buyer on LandPanda — whether in search results, featured sections, or buyer recommendations. It means one buyer saw your property. More impressions = more visibility." },
    { id: 2, q: "How is the cost calculated?", a: "The cost is fixed at ₹1.40 per impression. You set a budget (minimum ₹100, maximum ₹10,000), and the system automatically calculates how many impressions your budget will deliver." },
    { id: 3, q: "Can I stop a campaign anytime?", a: "Yes, absolutely. You can pause or stop your campaign at any time from the Ongoing Campaigns tab. Your remaining unspent budget stays in your wallet and can be used for future campaigns. There is no lock‑in period." },
    { id: 4, q: "Is there any commission charged?", a: "No. LandPanda charges zero commission on any property deal. You only pay for the impressions your listing receives. There are no hidden fees, no subscription charges, and no success fees." },
    { id: 5, q: "What is the difference between an impression, a view, and a lead?", a: "Impression = Your property was shown to a buyer (they saw your listing card). View = A buyer clicked and opened your full property page. Lead = A buyer initiated a chat or inquiry about your property. Each stage represents deeper buyer interest." },
    { id: 6, q: "Where will my boosted listing appear?", a: "Boosted listings appear in three key places: (1) Top of search results when buyers search in your area, (2) Featured Properties section on the homepage and category pages, and (3) Buyer Recommendations — shown to buyers whose preferences match your property." },
    { id: 7, q: "What happens when my budget runs out?", a: "Once your campaign budget is fully used up, the campaign automatically stops and your listing returns to its organic position. You can top up your wallet and launch a new campaign anytime to continue boosting." },
    { id: 8, q: "Can I get a refund for unused budget?", a: "Unused wallet balance can be refunded upon request. If a campaign was paused before the budget was exhausted, the remaining amount stays in your wallet for future use. For refund requests, please raise a dispute using the form above." }
  ];

  return (
    <>
     <div className="breadcrumb">
        <span className="light">LandPanda Ads</span>
        <span className="arrow">›</span>
        <span className="bold">Help & Support</span>
      </div>
   
    <div className="adshelp">
    <div className="page adshelp">
      <h1 className="heading">Help & Support</h1>
      <p className="sub">Have an issue with a campaign? Raise a dispute or browse our FAQs below.</p>

      <div className="layout">
        {/* LEFT */}
        <div className="left">
          <div className="card">
           <div className="topflex">
            <div>
              <div className="icons red">
                <i class="ri-flag-2-line text-red-500 text-lg"></i>
              </div>
            </div>
            <div>
            <h3>Raise a Dispute</h3>
            <p className="muted">We'll respond within 24 hours</p>
            </div>
</div>
<div className="whitecard">

            <label>Campaign *</label>
            <select>
              <option>Select a campaign</option>
            </select>

            <label>Issue Type *</label>
            <div className="btn-group">
              <button>Billing</button>
              <button>Impressions</button>
              <button>Other</button>
            </div>

            <label>Describe your issue *</label>
            <textarea placeholder="Please describe the issue in detail so we can help you faster..."></textarea>

            <div className="char">0/500</div>

            <button className="submit">Submit Dispute</button>
            </div>
          </div>

          <div className="card contact">
            <h3>Other Ways to Reach Us</h3>
            <p><div className="icons"><i class="ri-mail-line text-emerald-600"></i></div> ads-support@landpanda.in</p>
            <p><div className="icons"><i class="ri-phone-line text-emerald-600"></i> </div> +91 98765 43210 (Mon–Sat, 10am–6pm)</p>
            <p><div className="icons"><i class="ri-time-line text-emerald-600"></i></div>  Average response time: &lt;24 hours</p>
          </div>
        </div>

        {/* RIGHT */}
        <div className="right">
          <div className="card">
             <div className="topflex">
               <div>
              <div className="icons orange">
               <i class="ri-question-answer-line text-amber-500 text-lg"></i>
              </div>
            </div>
            <div>
            <h3>Frequently Asked Questions</h3>
            <p className="muted">Everything you need to know about LandPanda Ads</p>
</div></div>
<div className="whitecard">
 <div className="faq">
              {faqs.map((f) => (
                <div key={f.id} className="faq-item">
                  <div className="faq-q" onClick={() => setActive(f.id)}>
                    <div style={{display:'flex'}}>
                    <span className="num">{f.id}</span>
                    {f.q}
                    </div>
                    <span className="icon">{active === f.id ? "−" : "+"}</span>
                  </div>

                  {active === f.id && f.a && (
                    <div className="faq-a">{f.a}</div>
                  )}
                </div>
              ))}
            </div>
</div>
           
          </div>

          {/* PRICING */}
          <div className="pricing">
            <h3>Quick Reference — Pricing</h3>

            <div className="grid">
              {[
                ["₹100", "~71 impressions"],
                ["₹500", "~357 impressions"],
                ["₹1,000", "~714 impressions"],
                ["₹2,500", "~1,785 impressions"],
                ["₹5,000", "~3,571 impressions"],
                ["₹10,000", "~7,142 impressions"]
              ].map((item, i) => (
                <div className="p-card" key={i}>
                  <div className="price">{item[0]}</div>
                  <div className="imp">{item[1]}</div>
                </div>
              ))}
            </div>

            <div className="footer">
              Fixed rate: <b>₹1.40 per impression</b> · No commission · No lock-in · Pause anytime
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
       </>
  );
}

